import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconEstado from '../UI/IconEstado';
import { TIPOS_AUTORIZACIONES } from '../../../utils/constants';

const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
      backgroundColor: 'lightblue',
    },
});

export const MaterialItem = (props) => {
    const { item, idTipoSolicitud } = props;
    const classes = useRowStyles();

    return ( 
        <>
            <TableRow className={classes.root}>
                <TableCell component="th" scope="row">
                    <IconEstado
                        useColorTable={true}
                        texto={item?.estadoMaterial?.letra}
                        backgroundColor={item?.estadoMaterial?.color}
                        descripcion={item?.estadoMaterial?.descripcion}
                    />
                </TableCell>
                {idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION && <TableCell component="th" scope="row">
                    <IconEstado
                        useColorTable={true}
                        texto={item?.estadoCompraMaterial?.letra}
                        backgroundColor={item?.estadoCompraMaterial?.color}
                        descripcion={item?.estadoCompraMaterial?.descripcion}
                    />
                </TableCell>}
                <TableCell component="th" scope="row">
                    {item.material?.descripcion}
                </TableCell>
                <TableCell align="right">{item.cantidad}</TableCell>
                <TableCell align="center">
                    {item.recuperoSur ? 'SI' : 'NO'}
                </TableCell>
                <TableCell align="center">
                    {item.disponible ? 'SI' : 'NO'}
                </TableCell>
            </TableRow>
        </>
     );
}